import { gql, QueryHookOptions } from '@apollo/client';
import { useQueryAndRefetchOnUserChange } from '../../lib/hooks';
import { VersionsQuery } from '../types';

const VERSIONS_QUERY = gql`
  query Versions {
    versions {
      items {
        description
        adminNotes
        id
        createdAt
        number
        isComplete
        txnReportDataFifo
        txnReportDataLifo
        txnReportDataAverageCost
        txnReportDataMinimization
        txnReportDataMinimizationV2
      }

      status {
        isSavingCurrentVersion
        isRestoringVersion
        restoredVersionNumber
        lastRestoredAt
        latestStatus
        latestType
      }
    }
  }
`;

export const useVersionsQuery = (options?: QueryHookOptions<VersionsQuery>) =>
  useQueryAndRefetchOnUserChange<VersionsQuery>(VERSIONS_QUERY, {
    context: { batched: true },
    ...options,
  });
